import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import ss1 from "../assets/ss1.png";
import ss2 from "../assets/ss2.png";
import ss3 from "../assets/ss5.png";
import ss4 from "../assets/ss4.png";
import "swiper/css";
import "./Projects.css"
const Projects = () => {
    const [projects,setProjects] = useState([]);
  useEffect(() =>{
    fetch('https://amit-portfolio-server.vercel.app/')
    .then(res => res.json())
    .then(data => setProjects(data))
  },[]);
    return (
        <section className="">
          <h2 className="text-red-500 text-center text-4xl font-semibold my-6">
            Projects
          </h2>
          <div className="text-center mx-auto">
            <Swiper
              spaceBetween={40}
              breakpoints={{
                // when window width is >= 640px
                991: {
                  width: 992,
                  slidesPerView: 3,
                },
                // when window width is >= 768px
                768: {
                  width: 768,
                  slidesPerView: 2,
                },
                640: {
                  width: 640,
                  slidesPerView: 1,
                }
                
                
              }}
            >
              {
                projects.map(project => <SwiperSlide key={project.id}>
                  <div className="text-white py-6 px-12 border shadow-white rounded-lg ">
                    <Link to={`/project/${project.id}`}>
                      <div className='h-80 overflow-hidden image-wrap'>
                      <img
                        src={project.images[0]}
                        alt=""
                        className="w-full object-cover h-full object-top"
                      />
                      </div>
                      
                      <h3 className="text-lg font-bold ">{project.title}</h3>
                      <h5 className="text-xs text-red-500">
                        {
                          project.technology.slice(0, 3).map(tech => tech+' | ')
                        }
                      </h5>
                    </Link>
                  </div>
                </SwiperSlide>)
              }
              
              
            </Swiper>
          </div>
        </section>
    );
};

export default Projects;